import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import {
  firstSystemMessage,
  getLastAssistantMessageAtom,
  isLastMessageErrorAtom,
  isLoadingAtom,
  messagesAtom,
  messagesWithContentsAtom,
  setMessagesAtom,
  setSystemMessageAsError,
  updateLastAssistantMessageAtom,
  updateMessageFeedbackByIdAtom,
  updateMessagesAtom,
} from './atom';
import { SystemMessage } from './types';

export function useMessageById(id: string) {
  const updateMessageFeedback = useSetAtom(updateMessageFeedbackByIdAtom);
  const message = useAtomValue(messagesAtom).find((m) => m.id === id);
  return {
    message,
    updateMessageFeedback: (feedback: SystemMessage['feedback']) =>
      updateMessageFeedback({ id, feedback }),
  };
}

export function useAssistantMessage() {
  const [isLoading, setIsLoading] = useAtom(isLoadingAtom);
  const updateLastMessage = useSetAtom(updateLastAssistantMessageAtom);
  const setError = useSetAtom(setSystemMessageAsError);

  return { isLoading, setIsLoading, updateLastMessage, setError };
}

export function useIsLastMessageError() {
  return useAtomValue(isLastMessageErrorAtom);
}

export function useMessages() {
  const data = useAtomValue(messagesWithContentsAtom);
  const update = useSetAtom(updateMessagesAtom);
  const set = useSetAtom(setMessagesAtom);
  const assistantMessage = useAtomValue(firstSystemMessage);

  return { data, update, set, chatId: assistantMessage?.chatId };
}

export function useClearMessages() {
  const setMessages = useSetAtom(messagesAtom);

  return () => setMessages([]);
}

export function useLastAssistantMessage() {
  return useAtomValue(getLastAssistantMessageAtom);
}
